import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { InsuranceService } from '../../services/insurance/insurance.service';
import { LicenseDataService } from '../../services/agentLicense/license-data.service';
import { ParInsuranceService } from '../../services/par_insurance/par-insurance.service';
import { ParLicenseService } from '../../services/par_license/par-license.service';
import { ChangeLogService } from '../../services/change_log/change-log.service';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';

@Component({
  selector: 'app-insurance-docs-clear-dialog',
  templateUrl: './insurance-docs-clear-dialog.component.html',
  styleUrls: ['./insurance-docs-clear-dialog.component.css']
})
export class InsuranceDocsClearDialogComponent implements OnInit {
  logFormData: any;
  agentId: any;
  loginId: any;
  data;
  errMsg;
  errFlag: boolean = false;
  vendorName;
  firstName;
  lastName;
  
errorMessage: String = '';
errorEnable: boolean = false;

  constructor(private googleAnalyticsService:GoogleAnalyticsService,
    private changelogservice: ChangeLogService, public parinsdocservice: ParInsuranceService, public parlicdocservice: ParLicenseService, public licenseservice: LicenseDataService, public dialogRef: MatDialogRef<InsuranceDocsClearDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public removeData: any, public insurenceService: InsuranceService) { }

  ngOnInit() {
    this.data = this.removeData.data;
    this.vendorName = localStorage.getItem('AgentName');
    this.agentId = localStorage.getItem("AgentId");
    this.loginId = localStorage.getItem('loginID');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
  }

  submitForm() {
    this.logFormData = {
      "document_type": this.removeData.data.DocumentTypeName,
      "document_category": this.removeData.data.DocumentCategory,
      "transaction_type": "Delete",
      "modified_by" : this.loginId
    }
    if (this.removeData.type === 'insurance') {
      this.insurenceService.deleteAgentInsurance(this.data).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Delete a" + ' ' + this.removeData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
          this.insurenceService.load.next('success')
          this.logFormData.vendor_id = this.agentId;
          this.logFormData.document_type = this.removeData.data.DocumentType;
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => {},err=>{
            this.errMsg = 'Vendor Change Logs' + ' ' + err;;
          this.errFlag = true;
        });
          this.dialogRef.close();
      }, error => {
          this.errorMessage = error;
          this.errorEnable = true;
      })
    } else if (this.removeData.type === 'license') {
      this.licenseservice.deleteAgentInsurance(this.data).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Delete a" + ' ' + this.removeData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
          this.dialogRef.close();
          this.licenseservice.load.next('success')
          this.logFormData.vendor_id = this.agentId;
          this.logFormData.document_type = this.removeData.data.DocumentTypeName;
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => {},err=>{
            this.errMsg = 'Vendor Change Logs' + ' ' + err;;
          this.errFlag = true;
          });
      }, error => {
        this.errorMessage = error;
        this.errorEnable = true;
      })
    } else if (this.removeData.type === 'parinsurance') {
      this.parinsdocservice.deleteAgentInsurance(this.data).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Delete a" + ' ' + this.removeData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
          this.dialogRef.close();
          this.parinsdocservice.load.next('success')
          this.logFormData.document_type = this.removeData.data.DocumentTypeName;
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => {},err=>{
          this.errMsg = 'PAR Change Logs' + ' ' + err;;
          this.errFlag = true;
          });
      }, error => {
        this.errorMessage = error;
        this.errorEnable = true;
      })
    } 
    else if (this.removeData.type === 'parlicense') {
      this.parlicdocservice.deleteParLicense(this.data).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Delete a" + ' ' + this.removeData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
        this.dialogRef.close();
          this.parlicdocservice.load.next('success')
          this.logFormData.document_type = this.removeData.data.DocumentTypeName;
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => {},err=>{
            this.errMsg = 'PAR Change Logs' + ' ' + err;;
          this.errFlag = true;
          });
      }, error => {
        this.errorMessage = error;
        this.errorEnable = true;
      })
    }
  }

  onNoClick() {
    this.dialogRef.close();

  }

  clear() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/insurance-docs-clear-dialog/insurance-docs-clear-dialog.component.ts